'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartFooter = PushCartFooter;

var _reactRedux = require('react-redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _functional = require('../../../utils/functional');

var _i18n = require('../../../services/i18n');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartFooter(_ref) {
  var action = _ref.action,
      submitTo = _ref.submitTo,
      shippingCost = _ref.shippingCost,
      message = _ref.message;

  var lineItems = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.lineItems;
  });
  var lineItemsWithoutAnyFreeGifts = lineItems.filter(function (lineItem) {
    return !(0, _utils.isLineItemFreeGift)(lineItem);
  });

  var subtotalWithoutFreeGifts = lineItemsWithoutAnyFreeGifts.reduce(function (subtotal, lineItem) {
    return subtotal + lineItem.line_price;
  }, 0);

  var pushCartOverMinLimit = subtotalWithoutFreeGifts > window.theme.cartLimit;

  return _react2.default.createElement('div', { className: 'psh-Footer' }, _react2.default.createElement('div', { className: 'psh-Footer_Items psh-Footer_Items-footer psh-Footer_Items-border' }, _react2.default.createElement('div', { className: 'psh-Footer_Item' }, _react2.default.createElement('p', { className: 'psh-Footer_Label psh-Footer_Label-large' }, _react2.default.createElement('span', { className: 'util-Valign-m' }, (0, _i18n.t)('cart.drawer.total')), _react2.default.createElement('span', { className: 'psh-Footer_Taxes hdn-Xs clr-Grey_700' }, (0, _i18n.t)('products.product.product_incl_tax'))), _react2.default.createElement('p', { className: 'psh-Footer_Value psh-Footer_Label-large' }, (0, _functional.formatMoney)(subtotalWithoutFreeGifts + shippingCost))), message && _react2.default.createElement('div', { className: 'psh-Footer_Item' }, _react2.default.createElement('p', { className: 'psh-Footer_Label' }, message)), pushCartOverMinLimit ? _react2.default.createElement('div', { className: 'psh-Footer_Item' }, _react2.default.createElement('form', { className: 'psh-Footer_Form', action: action, method: 'POST' }, _react2.default.createElement('button', {
    id: 'CartCheckoutButton',
    className: 'psh-Footer_Submit psh-Footer_Submit-checkout btn-Primary',
    type: 'submit',
    name: submitTo
  }, (0, _i18n.t)('cart.drawer.checkout_securely')))) : _react2.default.createElement('div', { className: 'psh-Footer_Item' }, _react2.default.createElement('p', { className: 'psh-Footer_Label psh-Footer_Alert' }, (0, _i18n.t)('cart.cart_under_mov_msg')))));
}

PushCartFooter.propTypes = {
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.oneOf(['cart', 'checkout']),
  message: _propTypes2.default.string,
  shippingCost: _propTypes2.default.number
};